import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {

  const accessToken = sessionStorage.getItem("access_token");
  // console.log("🔹 Protected Route Check:", accessToken ? " Authenticated" : " No Token Found");

  if (!accessToken) {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
